import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Field, Select } from '@itds/elements/index.js';
import { STATES } from '@itds/Constants';

const LimitStates = ({ defaultState, handleSave, selectedStates }) => {
  const [default_state, setDefaultState] = useState(defaultState);
  const [states, setStates] = useState(
    selectedStates?.length ? selectedStates : STATES?.map(s => s.value)
  );

  const handleChange = e => {
    setDefaultState(e.target.value);
  };

  const selectAll = () => {
    if (states?.length === STATES?.length) {
      setStates([]);
    } else {
      setStates(STATES?.map(s => s.value));
    }
  };

  const handleChecklistChange = selected => {
    // if the currently selected states don't include the default_state, set default_state to ''
    if (!selected.includes(default_state)) {
      setDefaultState('');
    }
    setStates(selected);
  };

  const save = () => {
    return default_state === ''
      ? handleSave({ default_state: null, states })
      : handleSave({ default_state, states });
  };

  return (
    <div>
      <div style={{ display: 'flex', marginBottom: 30 }}>
        <Button inline={true} onClick={selectAll} small={true}>
          {states?.length === STATES?.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>
      <Field label='Default State'>
        <Select
          onChange={handleChange}
          options={STATES.filter(s => states.includes(s.value))}
          placeholder='-- Select State --'
          value={default_state || ''}
        />
      </Field>

      <Field label='Enabled States'>
        <Checklist
          columns={4}
          onChange={handleChecklistChange}
          options={STATES}
          selected={states ? states : []}
          style={{ margin: 4 }}
        />
      </Field>

      <Button disabled={!states?.length} inline={true} onClick={save}>
        Save Changes
      </Button>
    </div>
  );
};

LimitStates.propTypes = {
  defaultState: PropTypes.string,
  handleSave: PropTypes.func,
  selectedStates: PropTypes.array
};

export default LimitStates;
